package br.com.htms.inspeccaocampo.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import androidx.compose.ui.layout.ContentScale
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.jetbrains.skia.Image as SkiaImage
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Uint8Array
import org.khronos.webgl.get
import org.w3c.fetch.Response

@Composable
actual fun HtmsBackdrop(modifier: Modifier) {
    var bitmap by remember { mutableStateOf<ImageBitmap?>(null) }

    LaunchedEffect(Unit) {
        bitmap = loadHtmsBackground()
    }

    Box(modifier = modifier.fillMaxSize().background(Color(0xFF0B3D5C))) {
        val bmp = bitmap
        if (bmp != null) {
            // Cover em todas as larguras — preenche a tela (evita a “faixa” do Fit no celular).
            Image(
                bitmap = bmp,
                contentDescription = null,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Crop,
                alignment = androidx.compose.ui.Alignment.Center
            )
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color(0xFF0B3D5C).copy(alpha = 0.50f))
            )
        }
    }
}

private suspend fun loadHtmsBackground(): ImageBitmap? {
    return try {
        val response = window.fetch("bg_htms_energia2.png").await<Response>()
        if (!response.ok) return null
        val buffer = response.arrayBuffer().await<ArrayBuffer>()
        val u8 = Uint8Array(buffer)
        val bytes = ByteArray(u8.length) { i -> u8[i] }
        SkiaImage.makeFromEncoded(bytes).toComposeImageBitmap()
    } catch (_: Throwable) {
        null
    }
}
